import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import moment from "moment";
import "moment/locale/de";
import "moment/locale/it";

import dashboardDE from "./locales/dashboard/de.json";

import reservationsDE from "./locales/reservations/de.json";
import reservationsIT from "./locales/reservations/it.json";
import reservationsEN from "./locales/reservations/en.json";

import commonDE from "./locales/common/de.json";
import commonIT from "./locales/common/it.json";
import commonEN from "./locales/common/en.json";

import errorsDE from "./locales/errors/de.json";
import errorsIT from "./locales/errors/it.json";
import errorsEN from "./locales/errors/en.json";

const momentLocale = (language) => {
  const locale = language?.split("-")[0];

  return ["de", "it", "en"].includes(locale) ? locale : "de";
};

// Moment does not include non-English locales automatically when bundled by Vite.
// Keep its global locale aligned with the language selected by i18next.
moment.locale("de");
i18next.on("languageChanged", (language) =>
  moment.locale(momentLocale(language))
);

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "de",
    supportedLngs: ["de", "it", "en"],
    ns: ["dashboard", "reservations", "common", "errors"],
    detection: {
      order: ["path"],
    },
    resources: {
      de: {
        dashboard: dashboardDE,
        reservations: reservationsDE,
        common: commonDE,
        errors: errorsDE,
      },
      it: {
        reservations: reservationsIT,
        common: commonIT,
        errors: errorsIT,
      },
      en: {
        reservations: reservationsEN,
        common: commonEN,
        errors: errorsEN,
      },
    },
  });
